import * as c from "purify-ts/Codec";
import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form } from "trader.ts/ui.forms";
import { enrollmentid } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { renderDownloadExampleSection } from "../../client/download_example_button";
import { fileInputFieldForImage } from "../../client/fileinput";
import { renderSaveButton } from "../../client/savebutton";
import { fileb64 } from "../../lib/base64";
import { localStorageSpec } from "../../lib/localstorage";
import * as routes from "../../routes";

const enrollmentLS: localStorageSpec<{
  description: string;
  id: enrollmentid;
}> = {
  key: "classy_school_mutuality_config_enrollment_id",
  codec: c.Codec.interface({
    description: c.string,
    id: c.number as unknown as c.Codec<enrollmentid>,
  }),
};

export function render(opts: {
  signature_image: {
    data: fileb64;
    mimetype: string;
    name: string;
  } | null;
  logo_image: {
    data: fileb64;
    mimetype: string;
    name: string;
  } | null;
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("logo_image", [], async () =>
      fileInputFieldForImage({
        initial: opts.logo_image,
        label: "Afbeelding logo",
        initiallabel: "Logo",
        selectedlabel: "Logo",
        mkImageLink: () => "",
      }),
    )
    .addField("signature_image", [], async () =>
      fileInputFieldForImage({
        initial: opts.signature_image,
        label: "Afbeelding handtekening, verplicht",
        initiallabel: "Handtekening",
        selectedlabel: "Handtekening",
        mkImageLink: () => "",
      }),
    )
    .build();

  return (
    <div>
      <section className={style.equal_columns}>
        <div>{form.render()}</div>
        {opts.signature_image ? (
          renderDownloadExampleSection({
            findOptions: ({ searchstring }) =>
              rpc(routes.searchCampEnrollmentsSpec, undefined, {
                searchstring,
              }),
            showOption: (t) => t.description,
            makeDownloadLink: (t) =>
              routes.simulateMutualityCertificateConfigSpec.route.link({
                enrollmentid: t.id,
              }),
            inputLabel: "Zoek inschrijving in een kamp om attest te simuleren",
            lsSpec: enrollmentLS,
            close: () => {},
          })
        ) : (
          <span></span>
        )}
      </section>

      <section style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (values) =>
            rpc(routes.saveMutualityCertificateConfigSpec, undefined, values),
          reload: true,
          timeout: 250,
        })}
      </section>
    </div>
  );
}
